<template>
    <div class="content-wrapper">
        <div class="editor-content">
            <div class="preview-content" style="padding: 2rem 14rem;">
                <div class="preview">
                    <!-- Back Button -->
                    <div class="back-button-container mb-4">
                        <a class="modern-back-link" @click="redirectHomePage">
                            <app-icon name="chevron-left" />
                            <span>{{ $t('back') }}</span>
                        </a>
                    </div>

                    <!-- Job Header -->
                    <div v-if="pageBlocks[pageView].header" class="job-header-section mb-4">
                        <div class="title-container">
                            <h1 class="job-title mb-3">
                                {{ content.title }}
                            </h1>
                            <div class="title-accent"></div>
                        </div>

                        <!-- Location Display -->
                        <div v-if="data.location" class="location-container mb-3">
                            <div class="location-badge">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                    <circle cx="12" cy="10" r="3"/>
                                </svg>
                                <span class="location-text">{{ data.location.address }}</span>
                            </div>
                        </div>

                        <p class="job-subtitle mb-3">
                            {{ content.subtitle }}
                        </p>
                        
                        <!-- Job Details Card -->
                        <div class="details-wrapper">
                            <DetailsCard
                                :content="content"
                                :detailsStyle="detailsStyle"
                                :data="data"
                                :activePreview="activePreview"
                            />
                        </div>
                        
                        <!-- Top Apply Button -->
                        <div class="top-apply-section mb-3">
                            <a :href="applyLink" class="modern-apply-btn">
                                <span>{{ $t('apply_now') }}</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M5 12h14M12 5l7 7-7 7"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    <!-- Job Description -->
                    <div v-if="pageBlocks[pageView].body" class="job-description-section">
                        <div v-for="(section,index) in content.bodySection"
                             :key="index"
                             class="description-block">
                            <h5 class="section-heading"
                                :style="`font-size: ${headingsStyle.fontSize}; font-weight: ${headingsStyle.fontWeight}; letter-spacing: ${headingsStyle.letterSpacing}; color: ${headingsStyle.color};`">
                                {{ section.headings }}
                            </h5>
                            <div class="section-content"
                                 :style="`font-size: ${descriptionStyle.fontSize}; font-weight: ${descriptionStyle.fontWeight}; letter-spacing: ${descriptionStyle.letterSpacing}; color: ${descriptionStyle.color};`"
                                 v-html="purify(decode(section.description))">
                            </div>
                        </div>
                    </div>

                    <!-- Company Footer -->
                    <div v-if="pageBlocks[pageView].logo" class="company-footer-section mb-4">
                        <div class="footer-logo-container">
                            <img :src="logo" alt="Company Logo" class="footer-logo">
                        </div>
                    </div>

                    <!-- Copyright Text -->
                    <div v-if="pageBlocks[pageView].footer" class="copyright-section">
                        <p class="copyright-text">{{ companyText }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {urlGenerator} from "../../../Helpers/AxiosHelper";
import DetailsCard from './DetailsCard';
import {decode} from 'html-entities';
import {purify} from '../../Helpers/HTMLPurifyHelper.js'

export default {
    name: "CandidateJobPost",
    props: ['data', 'applyLink'],
    components: {
        DetailsCard
    },
    data() {
        return {
            year: moment(moment.now()).format("YYYY"),
            viewType: 'desktop',
            activePreview: 'desktop',
            decode,
            purify
        }
    },
    computed: {
        jobPostSetting() {
            if (typeof this.data['job_post_settings'] === 'string')
                return JSON.parse(this.data['job_post_settings']);
            return this.data['job_post_settings'];
        },
        content() {
            return this.jobPostSetting.content;
        },
        pageStyle() {
            return this.jobPostSetting.pageStyle;
        },
        pageBlocks() {
            return this.jobPostSetting.pageBlocks;
        },
        pageView() {
            return this.activePreview === 'desktop' ? 'defaultView' : 'mobileView'
        },
        titleStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'title')
        },
        subTitleStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'sub-title')
        },
        detailsStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'details')
        },
        headingsStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'headings')
        },
        descriptionStyle() {
            return this.pageStyle[this.pageView].find(item => item.key === 'description')
        },
        icon() {
            return this.jobPostSetting.icon ? this.jobPostSetting.icon : urlGenerator(window.settings.company_icon)
        },
        logo() {
            return urlGenerator(window.settings.company_logo);
        },
        companyText() {
            return `${this.$t('copyright_text') + ' ' + this.year + ' ' + this.$t('by') + ' '} ${window.settings?.company_name ? window.settings.company_name : ''}`;
        }
    },
    watch: {
        viewType: {
            handler: function (type) {
                this.toggleResponsivePreview(type)
            },
            immediate: true
        }
    },
    mounted() {
        this.checkViewType();
        window.onresize = () => {
            this.checkViewType();
        }
    },
    methods: {
        checkViewType() {
            this.viewType = window.innerWidth > 575 ? 'desktop' : 'mobile';
        },
        toggleResponsivePreview(previewType) {
            let preview = $('.preview-content .preview')
            if (previewType === 'desktop') {
                this.activePreview = 'desktop';
                preview.removeClass('mobile-preview');
                preview.addClass('desktop-preview');
            } else {
                this.activePreview = 'mobile';
                preview.removeClass('desktop-preview');
                preview.addClass('mobile-preview');
            }
        },
        redirectHomePage() {
            window.location.replace(urlGenerator('/'));
        },
    }
}
</script>

<style scoped lang="scss">
.content-wrapper {
    min-height: 100vh;
    background: #f8f9fa;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.editor-content {
    padding: 2rem 0;
}

.preview-content {
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
}

.preview {
    background: white;
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    position: relative;
    width: 100%;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: #008a8a;
    }
}

/* Back Button Styling */
.back-button-container {
    padding: 1.5rem 3rem 0;
}

.modern-back-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #008a8a;
    text-decoration: none;
    font-weight: 500;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0.5rem 0;
    
    &:hover {
        color: #006666;
        transform: translateX(-2px);
    }
    
    span {
        font-weight: 600;
    }
}

/* Company Logo Section */
.company-logo-section {
    padding: 0 3rem;
    text-align: center;
}

.logo-container {
    display: inline-block;
    width: 80px;
    height: 80px;
    border-radius: 20px;
    background: #f8f9fa;
    padding: 1rem;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
    border: 1px solid #e9ecef;
}

.company-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* Job Header Section */
.job-header-section {
    padding: 0 3rem 1.5rem;
    text-align: center;
    background: white;
    border-bottom: 1px solid #e9ecef;
}

.title-container {
    position: relative;
    margin-bottom: 1.5rem;
}

.title-accent {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #008a8a;
    border-radius: 2px;
    box-shadow: 0 2px 6px rgba(0, 138, 138, 0.2);
}

.job-title {
    font-size: 35px;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 0;
    color: rgb(49, 49, 49);
    letter-spacing: 1px;
}

.job-subtitle {
    font-size: 15px;
    line-height: 1.6;
    color: grey;
    margin-bottom: 1.5rem;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    font-weight: 300;
    letter-spacing: 1px;
    text-align: center;
}

/* Location Display Styling */
.location-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.location-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 50px;
    color: #475569;
    font-size: 0.875rem;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.2s ease;
    
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        border-color: #cbd5e1;
    }
    
    svg {
        color: #f4751f;
        flex-shrink: 0;
    }
}

.location-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
}

/* Top Apply Button Section */
.top-apply-section {
    text-align: center;
    margin-bottom: 1.5rem;
}

.top-apply-section .modern-apply-btn {
    padding: 0.875rem 2.5rem;
    font-size: 0.9375rem;
    background: #008a8a;
    color: white;
    text-decoration: none;
    border-radius: 12px;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 6px 20px rgba(0, 138, 138, 0.2);
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(0, 138, 138, 0.3);
        text-decoration: none;
        color: white;
        background: #006666;
    }
    
    &:active {
        transform: translateY(0);
    }
    
    svg {
        transition: transform 0.2s ease;
    }
    
    &:hover svg {
        transform: translateX(2px);
    }
}

.details-wrapper {
    margin: 1.5rem 0;
}

/* Job Description Section */
.job-description-section {
    padding: 1.5rem 3rem;
    background: white;
}

.description-block {
    margin-bottom: 1.5rem;
    
    &:last-child {
        margin-bottom: 0;
    }
}

.section-heading {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.75rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #e9ecef;
    position: relative;
    letter-spacing: -0.01em;
    
    &::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 50px;
        height: 2px;
        background: #008a8a;
        border-radius: 1px;
    }
}

.section-content {
    font-size: 1.0625rem;
    line-height: 1.7;
    color: #475569;
    font-weight: 400;
    
    ::v-deep h1, ::v-deep h2, ::v-deep h3, ::v-deep h4, ::v-deep h5, ::v-deep h6 {
        color: #1e293b;
        margin-top: 1.25rem;
        margin-bottom: 0.75rem;
        font-weight: 600;
    }
    
    ::v-deep p {
        margin-bottom: 1rem;
    }
    
    ::v-deep ul, ::v-deep ol {
        margin-bottom: 1rem;
        padding-left: 1.5rem;
    }
    
    ::v-deep li {
        margin-bottom: 0.5rem;
    }
    
    ::v-deep strong {
        color: #1e293b;
        font-weight: 600;
    }
}

/* Apply Button Section */
.apply-section {
    padding: 0 3rem;
    text-align: center;
}

.modern-apply-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1.125rem 3rem;
    background: #008a8a;
    color: white;
    text-decoration: none;
    border-radius: 16px;
    font-weight: 700;
    font-size: 1.0625rem;
    transition: all 0.3s ease;
    box-shadow: 0 8px 25px rgba(0, 138, 138, 0.25);
    border: none;
    cursor: pointer;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 35px rgba(0, 138, 138, 0.35);
        text-decoration: none;
        color: white;
        background: #006666;
    }
    
    &:active {
        transform: translateY(0);
    }
    
    svg {
        transition: transform 0.2s ease;
    }
    
    &:hover svg {
        transform: translateX(2px);
    }
}

/* Company Footer Section */
.company-footer-section {
    padding: 0 3rem;
    text-align: center;
}

.footer-logo-container {
    display: inline-block;
    padding: 1rem;
}

.footer-logo {
    height: 60px;
    width: auto;
    object-fit: contain;
}

/* Copyright Section */
.copyright-section {
    padding: 2rem 3rem;
    text-align: center;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
}

.copyright-text {
    margin: 0;
    color: #718096;
    font-size: 0.875rem;
    font-weight: 500;
}

/* Responsive Design */
@media (max-width: 768px) {
    .preview-content {
        padding: 1rem !important;
        width: 100%;
    }
    
    .preview {
        border-radius: 16px;
        margin: 0;
        width: 100%;
    }
    
    .back-button-container,
    .job-header-section,
    .job-description-section,
    .company-footer-section,
    .copyright-section {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
    
    .back-button-container {
        padding: 1rem 1.5rem 0;
    }
    
    .job-header-section {
        padding: 0 1.5rem 1rem;
    }
    
    .job-description-section {
        padding: 1rem 1.5rem;
    }
    
    .job-title {
        font-size: 28px;
    }
    
    .job-subtitle {
        font-size: 14px;
        max-width: 600px;
        font-weight: 300;
        letter-spacing: 1px;
        color: grey;
    }
    
    .section-heading {
        font-size: 1.375rem;
    }
    
    .section-content {
        font-size: 1rem;
    }
    
    .top-apply-section .modern-apply-btn {
        padding: 0.75rem 2rem;
        font-size: 0.875rem;
    }
    
    .location-badge {
        padding: 0.625rem 1.25rem;
        font-size: 0.8125rem;
        gap: 0.375rem;
        
        svg {
            width: 14px;
            height: 14px;
        }
    }
    
    .location-text {
        max-width: 250px;
    }
}

@media (max-width: 480px) {
    .preview-content {
        padding: 0.5rem !important;
        width: 100%;
    }
    
    .preview {
        border-radius: 12px;
        margin: 0;
        width: 100%;
    }
    
    .back-button-container,
    .job-header-section,
    .job-description-section,
    .company-footer-section,
    .copyright-section {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    
    .back-button-container {
        padding: 0.75rem 1rem 0;
    }
    
    .job-header-section {
        padding: 0 1rem 0.75rem;
    }
    
    .job-description-section {
        padding: 0.75rem 1rem;
    }
    
    .job-title {
        font-size: 24px;
    }
    
    .job-subtitle {
        font-size: 13px;
        max-width: 500px;
        font-weight: 300;
        letter-spacing: 1px;
        color: grey;
    }
    
    .section-heading {
        font-size: 1.25rem;
    }
    
    .section-content {
        font-size: 0.9375rem;
    }
    
    .title-accent {
        width: 50px;
        bottom: -8px;
    }
    
    .top-apply-section .modern-apply-btn {
        padding: 0.625rem 1.75rem;
        font-size: 0.8125rem;
    }
    
    .location-badge {
        padding: 0.5rem 1rem;
        font-size: 0.75rem;
        gap: 0.25rem;
        
        svg {
            width: 12px;
            height: 12px;
        }
    }
    
    .location-text {
        max-width: 200px;
    }
}
</style>

